import styled, { css } from 'styled-components';

export const Conf = styled.div``;

export const Wrap = styled.div`
    width: 150px;
    padding: 12px;
    font-size: 14px;
`;

export const ConfirmBtn = styled.button`
    border: 0;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    padding: 5px 8px;
    border-radius: 3px;
    ${getButtonType};
`;

ConfirmBtn.Group = styled.div`
    margin-top: 7px;
    padding-top: 7px;
    border-top: 1px solid #e7ecf0;

    button {
        margin-right: ${({ gap }) => gap + 'px'};

        &:last-child {
            margin-right: 0;
        }
    }
`;

function getButtonType({ theme, btnType }) {
    switch (btnType) {
        case 'alt': {
            return css`
                color: ${theme.buttons.dark.fg};
                background-color: ${theme.buttons.dark.bg};
            `;
        }

        case 'primary':
        default: {
            return css`
                color: ${theme.buttons.primary.fg};
                background-color: ${theme.buttons.primary.bg};
            `;
        }
    }
}
